import { useEffect, useState } from 'react';
import enUS from 'rc-picker/lib/locale/en_US';
import { ENG } from 'src/constants/languages';
import { useSelector } from 'react-redux';
import { selectLocale } from 'src/store/selectors/translationSelectors';
import { getLanguageByAppFormat } from 'src/translations/tools';
export default function usePickerLocale() {
    const [pickerLocale, setPickerLocale] = useState(enUS);
    const appLocale = useSelector(selectLocale);
    useEffect(() => {
        (async function importLocale() {
            const localeName = getLanguageByAppFormat(appLocale)?.localeName;
            const localeFileName = localeName?.replace('-', '_') || ENG.localeName;
            const locale = await import(`rc-picker/lib/locale/${localeFileName}.js`);
            setPickerLocale(locale.default);
        }());
    }, [appLocale]);
    return pickerLocale;
}
